export default "__VITE_ASSET__b5300291__"